module.exports = __webpack_public_path__ + "static/media/quran.38e97f51.jpg";